import { setClientPreferredOrganizationId } from "./clientActiveOrganization";

/**
 * Active org record for the current session (handles API returning organization as array).
 */
export function resolveOrganizationFromUserData(userData) {
  if (!userData) return null;

  const raw = userData.organization;
  if (raw && !Array.isArray(raw) && raw.organization_id != null) {
    return raw;
  }

  const orgList = Array.isArray(raw)
    ? raw
    : Array.isArray(userData.organizations)
      ? userData.organizations
      : [];

  const activeId =
    userData?.user_active_organization?.organization_id ??
    userData?.user_active_organization?.user_current_active_organization_id ??
    userData?.organization_id ??
    orgList[0]?.organization_id;

  if (activeId == null || activeId === "") {
    return orgList[0] || null;
  }

  return (
    orgList.find(
      (item) => Number(item?.organization_id) === Number(activeId)
    ) || orgList[0] || null
  );
}

export function resolveOrganizationId(userData) {
  const org = resolveOrganizationFromUserData(userData);
  return (
    org?.organization_id ??
    userData?.user_active_organization?.organization_id ??
    userData?.user_active_organization?.user_current_active_organization_id ??
    userData?.organization_id ??
    null
  );
}

export function resolveOrganizationUserId(userData) {
  const organizationId = resolveOrganizationId(userData);
  const metadata = Array.isArray(userData?.metadata) ? userData.metadata : [];

  return (
    userData?.organizationuser?.organization_user_id ??
    userData?.organization_user_id ??
    metadata.find(
      (item) => Number(item?.organization_id) === Number(organizationId)
    )?.organization_user_id ??
    metadata[0]?.organization_user_id ??
    null
  );
}

/**
 * After signup / org create: store a single active organization on userData (like Login flow).
 */
export function normalizeUserOrganizationSession(user) {
  if (!user) return user;

  const organization = resolveOrganizationFromUserData(user);
  const orgList = Array.isArray(user.organization)
    ? user.organization
    : Array.isArray(user.organizations)
      ? user.organizations
      : organization
        ? [organization]
        : [];

  const activeOrgId = organization?.organization_id;
  if (activeOrgId != null && activeOrgId !== "") {
    setClientPreferredOrganizationId(activeOrgId);
  }

  const metadata = Array.isArray(user.metadata) ? user.metadata : [];
  const organizationuser =
    user.organizationuser ||
    metadata.find(
      (item) => Number(item?.organization_id) === Number(activeOrgId)
    ) ||
    metadata[0] ||
    null;

  return {
    ...user,
    organizations: orgList.length ? orgList : organization ? [organization] : [],
    organization,
    organizationuser,
  };
}
